export default __webpack_public_path__ + "static/media/manage_heroicons_exclaimation-circle-blue.2fb3ad93.svg";